/**
 * Keyboard themes
 */
export enum AvailableKeyboardThemes {
    light = 'MonaTerminalLight',
    dark = 'MonaTerminalDark',
}
